
import React from 'react';
import MultiSelectGroup from './sections/MultiSelectGroup';
import SwitchesGroup from './sections/SwitchesGroup';
import EventRoomSection from './sections/EventRoomSection';
import ObservationsSection from './sections/ObservationsSection';

interface ServicesFormProps {
  readOnly?: boolean;
}

const ServicesForm = ({ readOnly = false }: ServicesFormProps) => {
  return (
    <div className="space-y-6">
      <MultiSelectGroup readOnly={readOnly} />
      <SwitchesGroup readOnly={readOnly} />
      <EventRoomSection readOnly={readOnly} />
      <ObservationsSection readOnly={readOnly} />
    </div>
  );
};

export default ServicesForm;
